import Reveal from './Reveal';

export default function SectionHead({ eyebrow, title, sub, align = 'left' }) {
  return (
    <Reveal className={`max-w-2xl ${align === 'center' ? 'mx-auto text-center' : ''}`}>
      <p
        className={`mb-4 flex items-center gap-3 font-mono text-xs font-semibold uppercase tracking-[0.3em] text-pulse ${
          align === 'center' ? 'justify-center' : ''
        }`}
      >
        <span className="inline-block h-px w-8 bg-pulse" />
        {eyebrow}
      </p>
      <h2 className="font-display text-3xl font-bold tracking-tight leading-[1.05] text-white sm:text-4xl lg:text-5xl">
        {title}
      </h2>
      {sub && <p className="mt-5 text-base leading-relaxed text-slate-400">{sub}</p>}
    </Reveal>
  );
}
